import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { useProductDescriptionStyles } from './styles';

const ProductDescription = ({ ...props }) => {
  const { orderId, sku, quantity } = props;
  const classes = useProductDescriptionStyles();

  return (
    <Box display="flex" flexDirection="column" justifyContent="space-between">
      <Box display="flex" flexDirection="column" justifyContent="space-around">
        <Typography className={classes.text}>
          <strong>Nº de compra: </strong>
          {orderId}
        </Typography>
        <Typography className={classes.text}>
          <strong>Sku: </strong>
          {sku}
        </Typography>
        <Typography className={classes.text}>
          <strong>Cantidad: </strong>
          {quantity}
        </Typography>
      </Box>
    </Box>
  );
};

ProductDescription.propTypes = {
  orderId: PropTypes.number,
  sku: PropTypes.string,
  quantity: PropTypes.number,
};

export default ProductDescription;
